import Cookies from "universal-cookie";

/**
 * Readable by JS — must match backend `SESSION_CSRF_COOKIE`.
 * If the API host differs from the page host, the API sets a parent `Domain` (default `.goryde.com`, overridable via `SESSION_CSRF_COOKIE_DOMAIN`);
 * otherwise `document.cookie` on the SPA will not contain the token.
 */
export const SESSION_CSRF_COOKIE_NAME = "csrf_token";

export const SESSION_CSRF_HEADER_NAME = "X-CSRF-Token";

let browserCookies: Cookies | undefined;

const getBrowserCookies = (): Cookies | undefined => {
  if (typeof document === "undefined") {
    return undefined;
  }
  browserCookies ??= new Cookies();
  return browserCookies;
};

export const readBrowserCookie = (name: string): string | undefined => {
  const cookies = getBrowserCookies();
  if (!cookies) {
    return undefined;
  }
  const raw = cookies.get(name);
  if (raw === undefined || raw === null) {
    return undefined;
  }
  return typeof raw === "string" ? raw : String(raw);
};
